<script setup>
import { computed } from 'vue';

import {
    ehVazio,
} from '@/commons/utils';

import {
    formataCnpj,
    formataTelefone,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const dadosBancariosFormatado = computed(() => {
    const d = props.solicitacao.dados;
    if (!d.banco_id) return null;

    const agencia = d.banco_agencia_dv
        ? `${d.banco_agencia} - ${d.banco_agencia_dv}`
        : d.banco_agencia;

    const conta = d.banco_conta_dv
        ? `${d.banco_conta} - ${d.banco_conta_dv}`
        : d.banco_conta;

    const partes = [`Agência ${agencia}`, `Conta ${conta}`];

    if (d.banco_operacao) partes.push(`Operação ${d.banco_operacao}`);
    if (d.chave_pix) {
        const pix = d.tipo_chave_pix_nome
            ? `Chave PIX: ${d.chave_pix} (${d.tipo_chave_pix_nome})`
            : `Chave PIX: ${d.chave_pix}`;
        partes.push(pix);
    }

    return partes.join(' • ');
})

const enderecoFormatado = computed(() => {
    const partes = [];

    if (!ehVazio(props.solicitacao.dados.endereco_logradouro)) {
        partes.push(props.solicitacao.dados.endereco_logradouro);
    }

    if (!ehVazio(props.solicitacao.dados.endereco_numero)) {
        partes.push(props.solicitacao.dados.endereco_numero);
    }

    if (!ehVazio(props.solicitacao.dados.endereco_complemento)) {
        partes.push(props.solicitacao.dados.endereco_complemento);
    }

    if (!ehVazio(props.solicitacao.dados.endereco_bairro)) {
        partes.push(props.solicitacao.dados.endereco_bairro);
    }

    if (!ehVazio(props.solicitacao.dados.endereco_cep)) {
        partes.push(`CEP: ${props.solicitacao.dados.endereco_cep}`);
    }

    let endereco = partes.join(', ');

    if (!ehVazio(props.solicitacao.dados.endereco_cidade)) {
        endereco += endereco ? ', ' : '';
        endereco += props.solicitacao.dados.endereco_cidade;
    }

    if (!ehVazio(props.solicitacao.dados.endereco_estado)) {
        endereco += `/${props.solicitacao.dados.endereco_estado}`;
    }

    return endereco;
})
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="solicitacao.dados.razao_social" :titulo="'Razão Social'"
        :conteudo="`${solicitacao.dados.razao_social}${solicitacao.dados.nome_fantasia ? ` (${solicitacao.dados.nome_fantasia})` : ''}`"
        :detalhe="`CNPJ: ${formataCnpj(solicitacao.dados.cnpj)}`" />

    <LabelDados v-if="solicitacao.dados.tipo_pessoa_juridica_nome" :titulo="'Tipo de Pessoa Jurídica'"
        :conteudo="solicitacao.dados.tipo_pessoa_juridica_nome" />

    <LabelDados v-if="solicitacao.dados.telefone || solicitacao.dados.email" :titulo="'Contatos'">
        <template #conteudo>
            <div v-if="solicitacao.dados.telefone" class="text-900 text-sm font-semibold">Telefone:
                {{ formataTelefone(solicitacao.dados.telefone) }}</div>
            <div v-if="solicitacao.dados.email" class="text-900 text-sm font-semibold">E-mail:
                {{ solicitacao.dados.email }}</div>
        </template>
    </LabelDados>

    <LabelDados
        v-if="solicitacao.dados.endereco_bairro || solicitacao.dados.endereco_cidade || solicitacao.dados.endereco_estado"
        titulo="Endereço" :conteudo="enderecoFormatado" />

    <LabelDados v-if="solicitacao.dados.inscricao_estadual" titulo="Inscrição Estadual"
        :conteudo="solicitacao.dados.inscricao_estadual" />

    <LabelDados v-if="solicitacao.dados.inscricao_municipal" titulo="Inscrição Municipal"
        :conteudo="solicitacao.dados.inscricao_municipal" />

    <LabelDados v-if="dadosBancariosFormatado" titulo="Dados Bancários" :conteudo="solicitacao.dados.banco_nome"
        :detalhe="dadosBancariosFormatado" tamanho_div="col-12" />

</template>